const TOKEN_KEY = 'userToken';

/** sessionStorage throws in private-mode / sandboxed contexts, so guard access. */
export const readAuthToken = (): string | null => {
  try {
    return window.sessionStorage.getItem(TOKEN_KEY);
  } catch {
    return null;
  }
};

export const writeAuthToken = (token: string): void => {
  try {
    window.sessionStorage.setItem(TOKEN_KEY, token);
  } catch {
    // storage unavailable - the session simply will not persist
  }
};

export const clearAuthToken = (): void => {
  try {
    window.sessionStorage.removeItem(TOKEN_KEY);
  } catch {
    // storage unavailable - nothing to clear
  }
};
